import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = { class: "table table-hover table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-90px" }, "Active since"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-90px" }, "Hours Worked"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Skills")
  ])
], -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "symbol symbol-45px me-5" }
const _hoisted_6 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href", "title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-phone me-1" }, null, -1)
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_13 = { class: "text-dark fw-bolder fs-6" }
const _hoisted_14 = {
  class: "text-end",
  style: {"width":"35% !important"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Img = _resolveComponent("Img")!

  return (_ctx.data.length == 0)
    ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: "Oops.. No referred users found"
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Img, {
                        src: user.photo_url
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("a", {
                        class: "text-dark fw-bolder text-hover-primary fs-6",
                        onClick: ($event: any) => (_ctx.handleRedirectToUser(user.id))
                      }, _toDisplayString(user.name), 9, _hoisted_7),
                      (user.phone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", null, [
                              _createElementVNode("a", {
                                class: "ps-0 text-muted fw-bold d-block fs-7 text-hover-primary",
                                href: `tel:${user.phone}`,
                                title: `Dial ${user.phone}`
                              }, [
                                _hoisted_10,
                                _createTextVNode(_toDisplayString(user.phone), 1)
                              ], 8, _hoisted_9)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", {
                        href: `mailto: ${user.email}`,
                        class: "text-muted fw-bold text-muted d-block fs-7 text-hover-primary"
                      }, _toDisplayString(user.email), 9, _hoisted_11)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatTime(user.created_at)), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(user.approved_hours ? user.approved_hours + " hrs" : "0 Hr"), 1)
                ]),
                _createElementVNode("td", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSkills(user.id), (skill) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: skill.id,
                      class: "badge rounded-pill bg-primary text-wrap ms-1 mb-2"
                    }, _toDisplayString(skill.name), 1))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
}